const SELLER_NAMES: Record<string, string> = {
  'KaTom Restaurant Supply': 'KaTom',
  'WebstaurantStore.com': 'Webstaurant',
}

/** The short name staff use for a crawled retailer. */
export function sellerName(seller: string | null | undefined): string {
  if (!seller) return 'A retailer'
  return SELLER_NAMES[seller] ?? seller
}
